import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import FinanceSidebar from './FinanceSidebar';
import FinanceHeader from './FinanceHeader';
import { Bars3Icon } from '@heroicons/react/24/outline';

const css = `
  @import url('https://fonts.googleapis.com/css2?family=Sora:wght@300;400;500;600;700&display=swap');
  .fl-root { display:flex; height:100vh; background:#f0f2f7; font-family:'Sora',sans-serif; overflow:hidden; }
  .fl-sidebar-wrap { flex-shrink:0; height:100vh; overflow:hidden; }
  .fl-main { flex:1; display:flex; flex-direction:column; min-width:0; height:100vh; overflow:hidden; }
  .fl-topbar { height:56px; background:white; border-bottom:1px solid #e8ebf4; display:flex; align-items:center; padding:0 24px; gap:12px; position:sticky; top:0; z-index:100; flex-shrink:0; }
  .fl-menu-btn { display:none; width:34px; height:34px; border:none; background:#f0f2f7; border-radius:9px; cursor:pointer; align-items:center; justify-content:center; }
  .fl-menu-btn svg { width:18px; height:18px; stroke:#6b7194; stroke-width:2; }
  .fl-breadcrumb { font-size:.8rem; color:#9094a8; flex:1; }
  .fl-breadcrumb strong { color:#1a1d2e; font-weight:600; }
  .fl-user { display:flex; align-items:center; gap:8px; }
  .fl-avatar { width:32px; height:32px; border-radius:9px; background:#0d9488; color:white; font-size:.78rem; font-weight:700; display:flex; align-items:center; justify-content:center; }
  .fl-user-name { font-size:.8rem; font-weight:600; color:#1a1d2e; }
  .fl-user-role { font-size:.68rem; color:#9094a8; }
  .fl-content { flex:1; padding:24px; overflow-y:auto; overflow-x:hidden; }
  .fl-overlay { display:none; position:fixed; inset:0; background:rgba(0,0,0,.4); z-index:199; }
  @media (max-width:768px) {
    .fl-menu-btn { display:flex; }
    .fl-sidebar-wrap { position:fixed; left:0; top:0; bottom:0; z-index:200; transform:translateX(-100%); transition:transform .25s ease; }
    .fl-sidebar-wrap.open { transform:translateX(0); }
    .fl-overlay.open { display:block; }
    .fl-content { padding:16px; }
    .fl-topbar { padding:0 14px; }
  }
`;

const FinanceLayout = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <style>{css}</style>
      <div className="fl-root">
        <div className={`fl-sidebar-wrap${open ? ' open' : ''}`}>
          <FinanceSidebar onClose={() => setOpen(false)} />
        </div>
        <div className={`fl-overlay${open ? ' open' : ''}`} onClick={() => setOpen(false)} />
        <div className="fl-main">
          <FinanceHeader onMenuClick={() => setOpen(true)} />
          <div className="fl-content"><Outlet /></div>
        </div>
      </div>
    </>
  );
};

export default FinanceLayout;